export default {
    more: 'more',
    learn_more: 'Learn More',
    view_more: 'VIEW MORE',
    search: 'SEARCH',
    view: 'View',
    tip: 'Tips',
    cancel: 'Cancel',
    ok: 'OK',
    submit: 'Submit',
    remark: 'Remark',
    upload: 'Upload',
    back: 'Back',
    search_placeholder: 'Search...',
    phone: 'Phone',
    address: 'Address',
    use: 'Use',
    confirm: 'Confirm',
    modify: 'Modify',
    success: 'Success!',
    delete: 'Delete',
    weight: 'Weight(kg)',
    lwh: 'L*W*H(cm)',
    pay: 'Pay',
    copy: 'Copy',
    copy_success: 'Copy successful!',
    copy_fail: 'Copy failed!',
    edit: 'Edit',
    mobile: 'Mobile',

    header_1: 'Home',
    header_2: 'Calculate Postage',
    header_3: 'Track&Trace',
    header_4: 'About us',
    header_5: 'News',
    header_6: 'Contact us',
    header_7: 'Sign In',
    header_8: 'Sign Up',
    header_9: 'FREE SIGN UP',
    header_10: 'Pages',

    banner_1: 'China to Australia Freight Forwarding – Licensed',
    banner_2: 'Reliable & Cost-Effective',
    banner_3: 'With s77G license, IATA certification, AA Class 1.3 site in Melbourne, and our own warehouse in Guangzhou, PolarPost provides trusted air & sea freight, consolidation, and customs clearance services between China and Australia.',
    banner_4: 'Get a Free Quote',

    banner_5: 'Licensed & Certified',
    banner_6: 's77G license in Melbourne',
    banner_7: 'IATA member',
    banner_8: 'AA Class 1.3 site',
    banner_9: 'PolarPost operates with full compliance and international recognition. As a s77G license holder in Melbourne, we are authorised to handle bonded cargo and customs processes efficiently. Our IATA certification ensures global safety and quality standards for air freight, while our AA Class 1.3 site confirms our ability to manage diverse cargo under strict security regulations. These accreditations demonstrate our professional reliability, giving customers the confidence that every shipment is managed securely and transparently. With PolarPost, your freight forwarding is supported by proven certifications and trusted expertise. ',
    banner_10: 'China Hub & Flexible Shipping',
    banner_11: 'Guangzhou warehouse',
    banner_12: 'Consolidation & inspection',
    banner_13: 'FCL, LCL, Air, e-commerce',
    banner_14: 'Our self-operated Guangzhou warehouse is the foundation of our China–Australia logistics service.We offer inspection, supplier coordination, consolidation, and export clearance at origin,ensuring cost-effective and reliable shipping. Whether you need FCL for large volumes, LCL for smaller loads,urgent air freight, or e-commerce parcel services, PolarPost provides flexible options to fit your business model.By combining a strong China hub with versatile shipping modes, we ensure smooth and efficient freight forwarding,helping clients reduce costs, increase frequency, and scale their operations with confidence.',
    banner_15: 'Digital Self-Service System',
    banner_16: 'Online declaration',
    banner_17: 'Real-time tracking',
    banner_18: 'Integrated payment',
    banner_19: 'PolarPost offers a modern digital logistics platform to simplify freight management.Clients can submit customs declarations online in minutes, reducing paperwork and delays.Our system provides real-time shipment tracking, ensuring full visibility at every stage of the supply chain.With integrated payment and order management tools, customers can complete the logistics workflow in one place.Designed for importers, e-commerce businesses, and SMEs, the self-service system delivers speed, transparency, and convenience.By combining digital technology with licensed expertise, PolarPost makes international freight more efficient and customer-friendly.',
    banner_20: 'End-to-End Service',
    banner_21: 'Supplier pickup in China',
    banner_22: 'Customs clearance in Australia',
    banner_23: 'Melbourne delivery',
    banner_24: 'PolarPost provides a complete end-to-end logistics solution.We collect goods directly from suppliers in China, arrange inspection and consolidation at our Guangzhou hub,and manage all export documentation. During transit, our team ensures compliance and efficiency,while in Australia, our customs clearance experts handle the import process with minimal delay.Finally, our last-mile delivery network in Melbourne guarantees timely distribution to your warehouse,retail outlet, or e-commerce fulfillment center. With every step managed under one roof,we simplify international shipping, save costs, and provide clients with a seamless logistics experience.',

    service_1: 'FCL Shipping',
    service_2: '(Full Container Load) Reliable FCL freight forwarding from China to Australia. Whether sealing at the factory or consolidating goods from multiple suppliers, PolarPost ensures safe and efficient container transport.',
    service_3: 'LCL Shipping',
    service_4: '(Less than Container Load) Cost-effective sea freight for smaller shipments. Consolidate multiple suppliers’ goods, reduce storage costs, and ship more frequently.',
    service_5: 'Air Freight',
    service_6: 'Urgent or small shipments? PolarPost air freight ensures fast, economical, and reliable delivery from China to Australia, including e-commerce parcels under AUD $1,000.',
    service_7: 'Customs Clearance',
    service_8: 'Licensed experts handle Australian customs clearance and brokerage, as well as clearance for imports from other countries.',

    advantage_1: 'Special Service – Consolidation Advantage',
    advantage_2: 'Ship from multiple suppliers in China? Send everything to our Guangzhou HUB → we consolidate into one shipment → you pay admin & customs fees only once. Hundreds of importers save thousands each year with PolarPost consolidation.',
    advantage_3: 'Trusted by Global Leaders & Top Brands',
    advantage_4: 'PolarPost is a recognized service provider for world-leading logistics companies, including:',
    advantage_5: 'DHL (Fortune Global 500) ',
    advantage_6: 'Australia Post (AUPOST) ',
    advantage_7: 'SF Express',
    advantage_8: 'JD Logistics',
    advantage_9: 'We are also proud logistics partners of well-known retail brands such as:',
    advantage_10: 'POPMART',
    advantage_11: 'MINISO',
    advantage_12: 'These partnerships reflect our professional capability, global network, and strong industry reputation.',
    advantage_13: 'Customs & Brokerage Advantage',
    advantage_14: 'Importing into Australia can be complex, but PolarPost makes it simple. Our licensed experts handle customs clearance, tariff classification, and duty payments, ensuring your cargo complies with all Australian regulations.',
    advantage_15: 'With our s77G license and AA Class 1.3 site in Melbourne, we can manage bonded cargo and special goods with speed and accuracy. Whether it’s air freight, sea freight, or e-commerce parcels, our brokerage services reduce delays and keep your supply chain moving smoothly.',

    support_1: 'SUPPORT',
    support_2: "The differences between air and ocean freight are seemingly apparent, but for importers and exporters, there is much more than meets the eye. Our guide to shipping air of ocean freight will help you understand the pros and cons of each and steer you in the direction that's best for your next shipment.",
    support_3: 'Information Centre',
    support_4: 'Container Dimensions-The best container you should use',
    support_5: 'Freight Shipping Hazardous Material Table',

    footer_1: 'About PolarPost',
    footer_2: 'Founded in 2014 in Melbourne, PolarPost (Polar Express Pty Ltd) has been providing professional freight forwarding solutions for over 9 years.',
    footer_3: '11 depots worldwide',
    footer_4: '14,000+ m² warehouse space',
    footer_5: 'Serving hundreds of Australian importers with reliable China–Australia logistics',
    footer_6: 'About Us',
    footer_7: 'Contact us',
    footer_8: 'Tel',
    footer_9: 'E-mail',
    footer_10: 'Wechat',

    calc_1: 'Cost Estimation',
    calc_2: 'Please enter the package information to complete the shipping estimate.',
    calc_3: 'Package info',
    calc_4: 'Mailing routes',
    calc_5: 'Pickup method',
    calc_6: 'Store Pickup',
    calc_7: 'Home delivery',
    calc_8: 'Address',
    calc_9: 'Phone',
    calc_10: 'Remark',
    calc_11: 'Your postcode',
    calc_12: 'International',
    calc_13: 'Domestic',
    calc_14: 'Total',
    calc_15: 'Note',
    calc_16: 'The quote showed above is for reference only. Tax and GST are exclusive. The quote is based on the dead weight or cubic weight(length*width*height/{amount} in cm) whichever is greater. No value-add services fee (eg.unpacking etc.) is included in the quote. Actual cost is subject to the frieght calculated when placing order.',
    calc_17: 'Please enter the item information to get quote',
    calc_18: 'Item weight is mandatory. Length, width and height are optional.',
    calc_19: 'From {amount}',
    calc_20: 'SUBMIT',
    calc_21: 'WEIGHT',
    calc_22: 'Weight',
    calc_23: 'NUM',
    calc_24: 'Num',
    calc_25: 'LENGTH / WIDTH / HEIGHT',
    calc_26: 'Length',
    calc_27: 'Width',
    calc_28: 'Height',


    track_1: 'Track a parcel',
    track_2: 'SEARCH',
    track_3: 'Input track number',
    track_4: 'Clear history search',


    article_1: 'SUPPORT',
    article_2: 'You’ve got questions, we’ve got answers.',
    article_3: 'No data available at the moment',
    article_4: 'Please enter the article title',
    article_5: 'TERMS & CONDITIONS',
    article_6: 'News',

    contact_1: 'Contact Us',
    contact_2: 'You’ve got questions, we’ve got answers.',
    contact_3: 'Name',
    contact_4: 'Email',
    contact_5: 'Phone',
    contact_6: 'Company',
    contact_7: 'Message',
    contact_8: 'Tell us about your shipment needs, e.g., from which city in China to Melbourne, cargo type, etc.',
    contact_9: 'Request a Quote',
    contact_10: 'About Us',
    contact_11: 'Polar Post is a trusted logistics provider specializing in',
    contact_12: 'China–Australia transport solutions.',
    contact_13: 'Licensed & Certified',
    contact_14: 'Melbourne AA Class 1.3 site, IATA member',
    contact_15: 'China Hub Advantage',
    contact_16: 'Self-operated Guangzhou warehouse for inspection, consolidation & clearance',
    contact_17: 'Flexible Shipping',
    contact_18: 'Air freight, sea freight (FCL/LCL), and e-commerce parcels',
    contact_19: 'Customs Expertise',
    contact_20: 'Professional clearance services with simplified declaration system',
    contact_21: 'With over 10 years of experience, Polar Post helps Australian importers reduce costs, streamline supply chains, and ensure smooth delivery from China to Australia.',
    contact_22: 'About Polar Post',

    login_1: 'Sign In',
    login_2: 'Enter your email and password to sign in',
    login_3: 'Email',
    login_4: 'Please input your email!',
    login_5: 'Password',
    login_6: 'Please input your password!',
    login_7: 'SIGN IN',
    login_8: "Don't have an account?",
    login_9: 'Sign Up',
    login_10: 'Forgot password?',
    login_11: 'Retrieve Password',

    register_1: 'Sign Up',
    register_2: 'Use these awesome forms to login or create new account in your project for free.',
    register_3: 'Verify email',
    register_4: 'Account info',
    register_5: 'Success',
    register_6: 'Please input your email!',
    register_7: 'Email',
    register_8: 'Please input your verification code!',
    register_9: 'Verification code',
    register_10: 'Please input your email verification code!',
    register_11: 'Email verification code',
    register_12: 'Please input your name!',
    register_13: 'Name',
    register_14: 'Please input your password!',
    register_15: 'Password',
    register_16: 'I agree the',
    register_17: 'Terms and Conditions',
    register_18: 'SEND EMAIL VERIFICATION CODE',
    register_19: 'SIGN UP',
    register_20: 'Sign In',
    register_21: 'Already have an account?',
    register_22: 'Please agree the Terms and Conditions',

    password_1: 'Retrieve password',
    password_2: 'Use these awesome forms to retrieve password.',
    password_3: 'Verify email',
    password_4: 'Password',
    password_5: 'Success',
    password_6: 'Please input your email!',
    password_7: 'Email',
    password_8: 'Please input your verification code!',
    password_9: 'Verification code',
    password_10: 'Please input your email verification code!',
    password_11: 'Email verification code',
    password_12: 'Please enter a new password!',
    password_13: 'New password',
    password_14: 'Please enter the new password again!',
    password_15: 'New password again',
    password_16: 'Verify email and send verification code',
    password_17: 'SIGN UP',
    password_18: 'Already have an account?',
    password_19: 'Sign In',
    password_20: 'The email cannot be empty!',

    side_1: 'Customer Portal',
    side_2: 'Package declaration',
    side_3: 'Create shipment',
    side_4: 'Shipments',
    side_5: 'Parcel Return',
    side_6: 'Address book',
    side_7: 'Account',
    side_8: 'Profile',
    side_9: 'Recharge',
    side_10: 'Credit log',

    info_1: 'Awaiting Forwarding',
    info_2: 'Awaiting Warehousing',
    info_3: 'Payment Required',
    info_4: 'Balance',
    info_5: 'All packages',
    info_6: 'Tracking number',
    info_7: 'Information',
    info_8: 'Weight/Volume',
    info_9: 'Time Received',
    info_10: 'Action',
    info_11: 'Status',
    info_12: 'Dispatch time',
    info_14: 'Awaiting Forwarding',
    info_15: 'Warehouse received parcels, please declare before shipping',
    info_16: 'Outbound package',
    info_17: 'Awaiting shipment or completed',
    info_18: 'Parcel Forwarding Warehouse',
    info_19: 'Copy Address',
    info_20: 'How to use ?',
    info_21: 'Tip',
    info_22: 'You can share the provided address with your sender, available in both Chinese and English versions. Please note that most Chinese suppliers prefer using the Chinese version of the address. Please include the shipping mark in the address to help us assign the shipment to your account. It would be greatly appreciated if you could request the sender to include at least one shipping mark on the shipment, if possible. If a shipping mark cannot be found on your cargo, you will need to register the shipment using your inland tracking number in our system. This will allow us to correctly assign the shipment to your account.',
    info_23: 'Hey',
    info_24: 'Watch the costs and the profits will take care of themselves. Click here to forecast the international freight.',
    info_25: 'Click here',
    info_25: 'Declare',
    info_27: 'Dispatching',
    info_28: 'On The Way',
    info_29: 'Onboard',
    info_30: 'Delivered',

    pd_1: 'Basic Info',
    pd_2: 'Tracking Number',
    pd_3: 'Tracking Company',
    pd_4: 'Pictures',
    pd_5: 'Remark',
    pd_6: 'Category',
    pd_7: 'Please select',
    pd_8: 'Product Name',
    pd_9: 'Purchase link',
    pd_10: 'Remarks',
    pd_11: 'Unit Price',
    pd_12: 'Number',
    pd_13: 'When an image should be uploaded:',
    pd_14: 'For category declaration:',
    pd_15: "If you're unable to find the appropriate category for your product, Please choose TBC and upload the product image so the team can assist in categorizing it correctly.",
    pd_16: 'For shipments over A$900:',
    pd_17: "If the total shipment value exceeds A$900, you must upload the invoice, as it's required for customs clearance by Australian authorities.",
    pd_18: 'Add Another',
    pd_19: 'Submit',
    pd_20: 'Remind',
    pd_21: 'Your current package contains different types of goods. After confirmation, the system will proceed accordingly to',
    pd_22: "The current package contains' pending items', please provide a purchase link and additional remarks. If there is a lack of information, the package needs to be verified by the administrator for the category of contents before submitting the transfer order.",
    pd_23: "Declared items must strictly comply with Australia's personal import requirements. According to Australian law, certain items cannot be imported through personal parcels. Non-compliance may result in legal consequences. Find more information here: ",
    pd_24: '! The current package has been received. If the information is correct, please click the claim package button. Otherwise, please click on it. If you have any questions, please contact the website customer service for assistance.',
    pd_25: 'Claim the package',
    pd_26: 'Have doubts?',
    pd_27: 'Operate',
    pd_28: 'Item No.',
    pd_29: 'Warehouse received parcels, please declare the package.',
    pd_30: 'Modified successfully!',
    pd_31: 'Deleting will result in information loss. Are you sure about deleting?',
    pd_32: 'View picture',
    pd_33: 'There are currently packages in the warehouse',
    pd_34: 'Logistics tracking number',
    pd_35: 'Logistics company',
    pd_36: 'L*W*H(cm)',
    pd_37: 'Wight',
    pd_38: "Administrator's remarks",
    pd_39: 'Storage time',
    pd_40: 'Picture',

    // 提交转运
    cs_1: 'Set Tags',
    cs_2: 'Tracking number',
    cs_3: 'Information',
    cs_4: 'Declare',
    cs_5: 'Ready for forwarding',
    cs_6: 'The sum of the declared value of current transit',
    cs_7: 'Add tags',
    cs_8: 'Remove tags',
    cs_9: 'Package Product Details',
    cs_10: 'Status',
    cs_11: 'Pending',
    cs_12: 'Inspecting',
    cs_13: 'Complete',
    cs_14: 'Departure',
    cs_15: 'Pending',
    cs_16: 'Dispatched',
    cs_17: 'Void',
    cs_18: 'Pending',
    cs_19: 'Returned',
    cs_20: 'Weight(kg) / Size(cm) / Value(A$)',
    cs_21: 'Information',
    cs_22: 'Time received',
    cs_23: 'Tag',
    cs_24: 'Please select package!',
    cs_25: 'Deleting will result in information loss. Are you sure about deleting?',
    cs_26: 'Modified successfully',
    cs_27: 'Modification failed',
    cs_28: 'Please select the package to be submitted first',
    cs_29: 'After deletion, the package will become a historical package. Are you sure to delete it?',
    cs_30: 'Please check and submit',
    cs_31: 'Success!',
    cs_32: 'Error!',
    cs_33: 'RETURN',
    cs_34: 'DELETE',
    cs_35: 'Package No.',

    // 退运包裹
    pr_1: 'Delivery details',
    pr_2: 'Tracking number',
    pr_3: 'Weight',
    pr_4: 'L*W*H (cm)',
    pr_5: 'Warehouse time',
    pr_6: 'Details',
    pr_7: 'Recipient',
    pr_8: 'Clear',
    pr_9: 'Name',
    pr_10: 'Phone',
    pr_11: 'Province/State',
    pr_12: 'City',
    pr_13: 'Region',
    pr_14: 'Zip code',
    pr_15: 'Address',
    pr_16: 'Please select and carefully read the terms',
    pr_17: 'Agreed terms',
    pr_18: 'Cost Details',
    pr_19: 'Overtime fee',
    pr_20: 'Points deduction',
    pr_21: 'Payable amount',
    pr_22: 'Disclaimer',
    pr_23: 'SUBMIT',
    pr_24: 'The current maximum available points',
    pr_25: 'Pickup method',
    pr_26: 'Pick up code',
    pr_27: 'Please enter a comment...',

    // 退运列表
    prl_1: 'Sn',
    prl_2: 'Recipient',
    prl_3: 'Sn',
    prl_4: 'Status',
    prl_5: 'Unpaid',
    prl_6: 'Processing',
    prl_7: 'Picking',
    prl_8: 'Shipped',
    prl_9: 'Void',
    prl_10: 'Type',
    prl_11: 'Recipient',
    prl_12: 'Price',
    prl_13: 'Creation time',
    prl_14: 'All',
    prl_15: 'Entrust',
    prl_16: 'Self taken',
    prl_17: 'Types',

    // 退运包裹详情
    prv_1: 'Back forecast Information',
    prv_2: 'Status',
    prv_3: 'Type',
    prv_4: 'Operation fee',
    prv_5: 'Address',
    prv_6: 'Package number',
    prv_7: 'Courier number',
    prv_8: 'Status',
    prv_9: 'Actual weight(kg)',
    prv_10: 'Picture',
    prv_11: 'Tracking number',
    prv_12: 'Creation time',
    prv_13: 'Sn',
    prv_14: 'Recipient',
    prv_15: 'Code',

    // 提交转运
    st_1: 'Shipment Details',
    st_2: 'Tracking number',
    st_3: 'Weight',
    st_4: 'Volume',
    st_5: 'L*W*H (cm)',
    st_6: 'Warehouse time',
    st_7: 'Details',
    st_8: 'Additional service',
    st_9: 'Recipient',
    st_10: 'Address Book',
    st_11: 'Clear',
    st_12: 'Mailing routes',
    st_13: 'Self Pickup',
    st_14: 'Home delivery',
    st_15: 'Please select and carefully read the terms',
    st_16: 'Agreed terms',
    st_17: 'Options',
    st_18: 'Cost Details',
    st_19: 'Goods Usage',
    st_20: 'Personal use',
    st_21: 'Commercial use',
    st_22: 'Company name',
    st_23: 'ABN',
    st_24: 'Billing email',
    st_25: 'Modify',
    st_26: 'Insurance costs',
    st_27: 'Insured amount(Insurance coverage ratio: {insure}%)',
    st_28: 'Insured amount(Insurance coverage ratio: 10%)',
    st_29: 'Coupon code',
    st_30: 'Current points: ',
    st_31: 'points',
    st_32: 'Points',
    st_33: 'Cost Details',
    st_34: 'End',
    st_35: 'Weight',
    st_36: 'Volume',
    st_37: 'International Postage',
    st_38: 'Additional service',
    st_39: 'End delivery',
    st_40: 'Store service fee',
    st_41: 'Customs declaration fee',
    st_42: 'Large item fee',
    st_43: 'Operation fee',
    st_44: 'Discount',
    st_44_1: 'Discount',
    st_45: 'Integral',
    st_46: 'Insurance',
    st_47: 'Amount',
    st_48: 'Disclaimer',
    st_49: 'Select address',
    st_50: 'Fee Description',
    st_51: 'Disclaimer',
    st_52: 'Express delivery details',
    st_53: 'Name',
    st_54: 'Picture',
    st_55: 'Category',
    st_56: 'Quantity',
    st_57: 'Unit Price',
    st_58: 'Modify value-added services',
    st_59: 'Choose value-added services',
    st_60: 'Usage of goods',
    st_61: 'Additional GST payment is required!',
    st_62: 'Usage of goods',
    st_63: 'Company name',
    st_64: 'ABN',
    st_65: 'Billing email',
    st_66: 'Value added service details',
    st_67: 'Dear user, hello!',
    st_68: 'Value added service fee is required',
    st_69: 'Need to charge a storage timeout fee',
    st_70: 'Total value-added expenses',
    st_71: 'Expired by',
    st_72: 'days',
    st_73: 'Please check the box first',
    st_74: 'The maximum number of points currently available:',
    st_75: 'The deduction amount using points cannot exceed the order amount',
    st_76: 'Please select a coupon',
    st_77: 'Please enter the company name',
    st_78: 'Please enter the ABN',
    st_79: 'Please enter the billing email',
    st_80: 'Delivery Method',
    st_81: 'Please enter a comment...',
    st_82: 'Value added services',

    // 包裹详情
    pv_1: 'Package Information',
    pv_2: 'Forecast Number',
    pv_3: 'Storage time',
    pv_4: 'Overtime fee',
    pv_5: 'Status',
    pv_6: 'Picture',
    pv_7: 'Time',
    pv_8: 'Courier number',
    pv_9: 'Package number',
    pv_10: 'Weight',
    pv_11: 'L, W, H',
    pv_12: 'Additional services',
    pv_13: 'Operation fee',
    pv_14: 'Explanation',
    pv_15: 'Shipment order No',
    pv_16: 'Remark',
    pv_17: 'Name',
    pv_18: 'Picture',
    pv_19: 'Category',
    pv_20: 'Quantity',
    pv_21: 'Unit Price',

    // 消息列表
    msg_1: 'All read',
    msg_2: 'Title',
    msg_3: 'Sender',
    msg_4: 'Title',
    msg_5: 'Status',
    msg_6: 'Sender',
    msg_7: 'Content',
    msg_8: 'Creation time',
    msg_9: 'Action',
    msg_10: 'Are you sure to delete?',
    msg_11: 'Are all message marked as read?',
    msg_12: 'Admin',

    // 订单列表
    o_1: 'Status',
    o_2: 'Number',
    o_3: 'Back',
    o_4: 'Pay',
    o_5: 'PSN/Status',
    o_6: 'Weight',
    o_7: 'Length/Width/Height',
    o_8: 'The order is currently being processed',
    o_9: 'View more',
    o_10: 'Sn',
    o_11: 'Line',
    o_12: 'Delivery Method',
    o_13: 'Weight / Price',
    o_14: 'Creation Time',
    o_15: 'All',
    o_16: 'Waiting',
    o_17: 'Inspecting',
    o_18: 'Confirm',
    o_19: 'Finish',
    o_20: 'Self-pickup',
    o_21: 'Shipping',
    o_22: 'PSN/Status',
    o_23: 'Weight',
    o_24: 'Length/Width/Height',
    o_25: 'Are you sure about the operation?',

    // 订单详情
    ov_1: 'Information',
    ov_2: 'Delivery details',
    ov_3: 'Order Information',
    ov_4: 'Personal',
    ov_5: 'Business',
    ov_6: 'Weight',
    ov_7: 'Volume',
    ov_8: 'International shipping fee is',
    ov_9: 'Additional Service Fee is',
    ov_10: 'Terminal delivery fee is',
    ov_11: 'Store service fee is',
    ov_12: 'Customs declaration fee is',
    ov_13: 'GST is',
    ov_14: 'Large item fee is',
    ov_15: 'Additional fee is',
    ov_16: 'Operation fee is',
    ov_17: 'Discount amount is deducted by',
    ov_18: 'Points deduction',
    ov_19: 'Activity full reduction deduction',
    ov_20: 'GST fee for commercial purposes is',
    ov_21: 'Insurance amount is',
    ov_22: 'Total payable is ',
    ov_23: 'Name',
    ov_24: 'Address',
    ov_25: 'Sn',
    ov_26: 'Status',
    ov_27: 'Pickup method',
    ov_28: 'Line',
    ov_29: 'Recipient',
    ov_30: 'Phone',
    ov_31: 'Address',
    ov_32: 'Repacking',
    ov_33: 'Creation time',
    ov_34: 'Additional services',
    ov_35: 'Product usage',
    ov_36: 'Prepacked Parcels',
    ov_37: 'Packed Packages',
    ov_38: 'Cost',
    ov_39: 'Tracking number',
    ov_40: 'Prepacked Parcel Tracking Number ',
    ov_41: 'Status',
    ov_42: 'Weight(kg)',
    ov_43: 'L*W*H',
    ov_44: 'Details',
    ov_45: 'Creation',
    ov_46: 'Delivery time',
    ov_47: 'Picture',
    ov_48: 'Prepacked parcel tracking number',
    ov_49: 'Additional services',
    ov_50: 'Product details',
    ov_51: 'Creation time',
    ov_52: 'Quantity',
    ov_53: 'Store information',

    // 支付页面
    pay_1: 'Your order has been successfully submitted. Please confirm the information before making the payment!',
    pay_2: 'You have submitted a return shipment, please confirm the information before making the payment!',
    pay_3: 'You have submitted the verification, please confirm the information before making the payment.',
    pay_4: 'You have submitted the supplementary payment for verification. Please confirm the information before making the payment.',
    pay_5: 'After successful payment, we will ship as soon as possible',
    pay_6: 'After successful payment, we will process it as soon as possible',
    pay_7: 'Order sn',
    pay_8: 'Payment sn',
    pay_9: 'Amount information:',
    pay_10: 'International freight charges',
    pay_11: 'Value added service fees',
    pay_12: 'End delivery',
    pay_13: 'Store service fee',
    pay_14: 'Customs declaration fee',
    pay_15: 'Large item fee',
    pay_16: 'Additional fees',
    pay_17: 'Operation fee',
    pay_18: 'Discount amount deduction',
    pay_19: 'Points deduction',
    pay_20: 'Activity full reduction deduction',
    pay_21: 'GST fees for commercial purposes',
    pay_22: 'Insurance amount',
    pay_23: 'Number of packages',
    pay_24: 'Estimated payment weight',
    pay_25: 'Estimated payment volume',
    pay_26: 'Amount information',
    pay_27: 'Payment method',
    pay_28: 'Additional handling fees are required',
    pay_29: 'Safe Australian dollar payment method',
    pay_30: 'Balance payment',
    pay_31: 'Your current balance',
    pay_32: 'Order Summary',
    pay_33: 'Order amount',
    pay_34: 'Coupon',
    pay_35: 'Balance deduction',
    pay_36: 'Points deduction',
    pay_37: 'Payable amount',
    pay_38: 'Service charge',
    pay_39: 'Actual payment amount',
    pay_40: 'Confirm payment',
    pay_41: 'Upload credentials',
    pay_42: 'Offline payment information',
    pay_43: 'Payment method',
    pay_44: 'Title of account',
    pay_45: 'Bank account',
    pay_46: 'Amount of money',
    pay_47: 'Sn',
    pay_48: 'Credentials',
    pay_49: 'Scan code payment',
    pay_50: 'Please upload the voucher!',
    pay_51: 'Payment successful!',
    pay_52: 'The page will automatically redirect in {second} seconds, you can click to directly redirect',
    pay_53: 'View details',
    pay_54: 'Order Again',
    pay_55: 'Balance Again',

    // 地址列表
    a_1: 'New Address',
    a_2: 'Name',
    a_3: 'Phone',
    a_4: 'Postcode',
    a_5: 'Name',
    a_6: 'Phone',
    a_7: 'Address1',
    a_8: 'Address2',
    a_9: 'Area/State/Postcode',
    a_10: 'Name',
    a_11: 'Phone',
    a_12: 'Address',
    a_13: 'Postcode',
    a_14: 'Creation time',
    a_15: 'Action',
    a_16: 'Are you sure to delete?',
    a_17: "'Name' is required!",
    a_18: "'Phone' is required!",
    a_19: "'State' is required!",
    a_20: "'Area' is required!",
    a_21: "'Postcode' is required!",
    a_22: "'Address' is required!",

    // 余额记录
    cd_1: 'Types',
    cd_2: 'Sn',
    cd_3: 'Type',
    cd_4: 'Fee(A$) / Balance(A$)',
    cd_5: 'Sn',
    cd_6: 'Remark',
    cd_7: 'Creation time',
    cd_8: 'All',
    cd_9: 'Entry(Admin)',
    cd_10: 'Expenses(Admin)',
    cd_11: 'Expenses(Payment)',
    cd_12: 'Expenses(Freight)',
    cd_13: 'Entry(Recharge)',

    // 物流信息
    pg_1: 'Shipment Overview',
    pg_2: 'Dispatching',
    pg_3: 'On The Way',
    pg_4: 'Onboard',
    pg_5: 'Delivered',
    pg_6: 'Tracking Number',
    pg_7: 'Order SN',
    pg_8: 'Delivery Method',
    pg_9: 'Line',
    pg_10: 'Status',
    pg_11: 'Creation Time',
    pg_12: 'Phone',
    pg_13: 'Address',
    pg_14: 'Store information',

    // 会员信息
    pf_1: 'Build Your Profile',
    pf_2: 'This information will let us know more about you.',
    pf_3: 'Nickname',
    pf_4: 'Phone',
    pf_5: 'Password',
    pf_6: "Let's start with the basic information",
    pf_7: 'Uploading your profile picture and entering your nickname is more comprehensive for your personal information',
    pf_8: 'Level',
    pf_9: 'Member Code',
    pf_10: 'Nickname',
    pf_11: "Let's start binding phone numbers",
    pf_12: 'Enter your phone number to obtain a verification code to bind your phone number',
    pf_13: 'Phone',
    pf_14: 'Verification code',
    pf_15: 'Resend',
    pf_16: 'send',
    pf_17: "Let's change the password",
    pf_18: 'Enter the old password, then enter the new password, and finally enter the new password again to confirm',
    pf_19: 'Old password',
    pf_20: 'New password',
    pf_21: 'New password again',
    pf_22: 'Please upload your profile picture!',

    // 充值
    r_1: 'Recharge amount',
    r_2: 'Currency',
    r_3: 'Recharge amount',
    r_4: 'Recharge member code',
    r_5: 'Payment method',
    r_6: 'Additional handling fees are required',
    r_7: 'Safe Australian dollar payment method',
    r_8: 'Confirm payment',
    r_9: 'Upload credentials',
    r_10: 'Offline payment information',
    r_11: 'Payment method',
    r_12: 'Title of account',
    r_13: 'Bank account',
    r_14: 'Sn',
    r_15: 'Credentials',
    r_16: 'Scan code payment',
    r_17: 'Please select the recharge amount!',
    r_18: 'Please enter the recharge amount!',
    r_19: 'Please choose a recharge method!',
    r_20: 'Please upload the voucher!',
    r_21: 'Amount',


}